/* Multi-item cart permalink helper for Shopify (Empire theme) */
(function () {
  function parseItems(str) {
    return str
      .split(",")
      .map((part) => {
        const [idRaw, qtyRaw] = part.split(":");
        const id = parseInt(idRaw, 10);
        const quantity = parseInt(qtyRaw || "1", 10);
        if (Number.isFinite(id) && Number.isFinite(quantity) && quantity > 0) {
          return { id, quantity };
        }
        return null;
      })
      .filter(Boolean);
  }

  // /cart/123:1,456:2 style
  function itemsFromPath() {
    const path = window.location.pathname || "";
    if (!path.startsWith("/cart/")) return null;
    const seg = decodeURIComponent(path.slice("/cart/".length));
    if (!seg || seg.indexOf(":") === -1) return null;
    return parseItems(seg);
  }

  // ?add=123:1,456:2 (optional alternate)
  function itemsFromQuery() {
    const qs = new URLSearchParams(window.location.search || "");
    const add = qs.get("add") || qs.get("items");
    if (!add) return null;
    return parseItems(decodeURIComponent(add));
  }

  function addItems(items) {
    if (!items || !items.length) return;

    // Prevent double-adds on refresh/back
    const key = "multi_cart_done";
    const marker = window.location.pathname + window.location.search;
    if (sessionStorage.getItem(key) === marker) {
      // Already processed this exact URL—just go to cart.
      window.location.replace("/cart");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }), // one request with all items
    })
      .then(function () {
        sessionStorage.setItem(key, marker);
        window.location.replace("/cart");
      })
      .catch(function () {
        // Even if something fails, go to cart so user isn’t stuck
        window.location.replace("/cart");
      });
  }

  function run() {
    const items = itemsFromPath() || itemsFromQuery();
    if (items && items.length) addItems(items);
  }

  // Run early, but after DOM is ready (works alongside Empire's JS)
  document.addEventListener("DOMContentLoaded", run);
})();
